<template>
    <div class="part3" id="animate3">
        <div class="img-container">
            <div class="img-box">
                <img id="img5" class="img-show" src="/assets/~/media/images/activity/2026summer/pc/part-k3.png" alt="">
            </div>
            <div style="margin-left: calc(18 / 2200 * 100vw);" class="img-box">
                <img id="img6" class="img-show" src="/assets/~/media/images/activity/2026summer/pc/part-k5.png" alt="">
            </div>
        </div>
    </div>
  </template>

  <script>
  import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
  // import Firstpage from "./Firstpage.vue";
  export default {
    data() {
      return {
        isPortrait: isPortraitFun(),
        minip: false,
      };
    },
    mounted: function () {
      /**
        window.addEventListener('scroll', function() {
            var vh = window.innerHeight;
            var vw = window.innerWidth;
            var Container1Element = document.getElementById('animate3');
            var pageTop= document.getElementById("animate3").getBoundingClientRect().top
            var imgElement1 = document.querySelector('#img5')
            var imgElement2 = document.querySelector('#img6')
            if(pageTop <= vh/1.5){
                imgElement1.classList.add('img-show');
                imgElement2.classList.add('img-show');
            }
            else if( pageTop > vh/2 && pageTop <= vh  ){
                imgElement1.classList.remove('img-show');
                imgElement2.classList.remove('img-show');
            }
        })
       **/
    },
    methods: {
    },
  };
  </script>

  <style lang="scss" scoped>
  .part3 {
        //background-color: #EEEEEE;
    // background-image:  url('https://uat.kia.cn/assets/~/media/images/activity/2026summer/pc/part3-bg.jpg');

    //      background-size: cover;
         width: 100%;
        height: calc(1154 / 2200 * 100vw);
        padding-bottom: calc(250 / 2200 * 100vw);
        padding-top: calc(100 / 2200 * 100vw);
        display: flex;
        align-items: center;
        justify-content: center;
        .img-container {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .img-box {
            // border: dashed 1px grey ;
            img {
                width: calc(857 / 2200 * 100vw);
                height: calc(802 / 2200 * 100vw);
                clip-path: inset(0 0 0 100%);
                transition: all 1s;
                transition-delay: 0s;
            }
            .img-show {
                clip-path: inset(0 0 0 0);
                transition-delay: 0.5s;
            }
        }
  }

  </style>
